import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { createUseStyles } from '../../../helpers/createStyles'
import { getGridGutter, theme } from '../../../styles/theme'
import ResponsiveImage from '../../ResponsiveImage'
import ColorList from './ColorList'
import ColorName, { colorNameNumberPropTypes } from './ColorName'
import ColorExplorerNavigation, { colorExplorerNavigationPropTypes } from './ColorExplorerNavigation'

const ColorGroup = ({
  group,
  onPressNext,
  onPressPrev,
  nextDisabled,
  prevDisabled,
  num,
  total
}) => {
  const styles = useStyles()
  const [active, setActive] = useState(null)

  useEffect(() => {
    setActive(null)
  }, [group])

  if (!group) {
    return null
  }

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          <ColorName name={group.name} num={num} total={total} />
          <ColorExplorerNavigation
            onPressPrev={onPressPrev}
            onPressNext={onPressNext}
            nextDisabled={nextDisabled}
            prevDisabled={prevDisabled}
          />
        </div>
        <p className={styles.description}>{group.description}</p>
        {group.colors?.length > 0 && (
          <ColorList
            colors={group.colors}
            active={active}
            setActive={setActive}
          />
        )}
      </div>
      <div className={styles.imagePanel}>
        <ResponsiveImage className={styles.image} image={group.image} />
        {active && (
          <ResponsiveImage key={active._key} className={styles.colorImage} image={active.image} background='transparent' showPreview={false} fadeInDuration={0.45} />
        )}
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row-reverse',
      height: '100vh'
    }
  },
  description: {
    marginBottom: theme.spacing(3)
  },
  content: {
    padding: `0 ${getGridGutter()}px`,
    flex: 1
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${theme.spacingPx(4)} 0`
  },
  imagePanel: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      width: '55% !important',
      height: '100%'
    }
  },
  image: {
    minHeight: 470,
    [theme.breakpoints.up('md')]: {
      height: '100%'
    }
  },
  colorImage: {
    top: '50%',
    transform: 'translate(-50%, -50%)',
    left: '50%',
    maxWidth: '90%',
    maxHeight: '90%',
    position: 'absolute !important',
    zIndex: 10,
    [theme.breakpoints.up('md')]: {
      maxWidth: '90%',
      maxHeight: '90%'
    }
  }
})

ColorGroup.propTypes = {
  group: PropTypes.object,
  ...colorNameNumberPropTypes,
  ...colorExplorerNavigationPropTypes
}

export default ColorGroup
